exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".infl-fe__style__points___3U4i8 {\n  display: flex;\n  flex-direction: row;\n  font-size: 18px;\n}\n.infl-fe__style__pointsAmt___31mrP {\n  position: relative;\n  top: 1px;\n  margin-left: 7px;\n  font-size: 16px;\n  font-weight: 300;\n  color: #232B34;\n}\n", ""]);

// Exports
exports.locals = {
	"points": "infl-fe__style__points___3U4i8",
	"pointsAmt": "infl-fe__style__pointsAmt___31mrP"
};